import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const DocumentosInstitucionales = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Documentos Institucionales</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Mesa de Ayuda al Cliente</b>
                  </p>
                </td>
                <td>
                  <p>
                  Para ofrecer un soporte técnico ágil y consistente, es necesario 
                  un documento estandarizado que guíe tanto al cliente como al equipo 
                  de mesa de ayuda. Este formato describirá los canales de contacto 
                  (teléfono, correo electrónico, portal web), el flujo interno de atención 
                  (recepción, diagnóstico, solución y cierre), así como los niveles de escalación 
                  según la complejidad o criticidad del incidente. Así, se garantiza transparencia, 
                  tiempos de respuesta definidos y una resolución efectiva de los requerimientos del cliente.
                  </p>
                </td>
                <td>

                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/documentos-institucionales/operaciones-generales"
                    disabled
                  >
                    Procedimiento
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/documentos-institucionales/mesa-ayuda-cliente"
                  >
                    Formato
                  </Button>

                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>Control de Cambios</b>
                  </p>
                </td>
                <td>
                  <p>
                  En proyectos en curso, los cambios en alcance, tiempos o recursos pueden afectar 
                  la calidad, el presupuesto y los plazos de entrega. Para gestionar adecuadamente 
                  estas variaciones, es imprescindible contar con un documento de Control de Cambios 
                  que registre solicitudes, justificaciones, impacto estimado, autorizaciones y seguimiento. 
                  Así se mantiene la trazabilidad, la comunicación transparente con stakeholders y se mitigan riesgos de desviación.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/control-de-cambios.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato Control de Cambios
                  </a>{" "}
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>
                    <b>Portafolio</b>
                  </p>
                </td>
                <td>
                  <p>
                  Descripción:
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/documentos-institucionales/mesa-ayuda-cliente"
                  >
                    Formato
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default DocumentosInstitucionales;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
